/**
 * @generated SignedSource<<7ddb7d5913c8c55852db4d6733e5bb20>>
 * @relayHash 80cc266842082413e538d50757f47f89
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID dcf085bcee24c1c5f81e54ab3deb232040624eeb8e37d61492207f620a0530b9

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { decomposedOriginalEstimateQuery } from './decomposedOriginalEstimateQuery.graphql';

const node: PreloadableConcreteRequest<decomposedOriginalEstimateQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "dcf085bcee24c1c5f81e54ab3deb232040624eeb8e37d61492207f620a0530b9",
    "metadata": {},
    "name": "decomposedOriginalEstimateQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
